export default __webpack_public_path__ + "static/media/1083.f1917973.png";